import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  typography: {
    fontFamily: ['PJ_WangNgan']
  },
  overrides: {
    MuiInputBase: {
      input: {
        fontSize: 'x-large'
      }
    }
  }
});
export default theme;
